import React from 'react';
import {useSidebarContext} from '@erkport/context/AppContextProvider/SidebarContextProvider';
import {StyledAppLogo} from './index.styled';

type AppLogoProps = {
  hasSidebarColor?: boolean;
};
const AppLogo: React.FC<AppLogoProps> = ({hasSidebarColor}) => {
  const {sidebarColorSet} = useSidebarContext();
  return (
    <StyledAppLogo>
      {hasSidebarColor && sidebarColorSet.mode === 'dark' ? (
        <a href='/'>
          <img src='/assets/images/logo-white-with-name.png' />
        </a>
      ) : (
        <a href='/'>
          <img src='/assets/images/logo-with-name.png' />
        </a>
      )}
    </StyledAppLogo>
  );
};

export default AppLogo;
